// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function BenchmarkOverrideFromJSON(json) {
    return {
        'benchmarkId': !exists(json, 'benchmarkId') ? undefined : json['benchmarkId'],
    };
}
export function BenchmarkOverrideToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'benchmarkId': value.benchmarkId,
    };
}
